import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WarningIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Warning",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.47 28.59h21.07A3.47 3.47 0 0 0 30 25.12c0-.64-.17-1.23-.47-1.75v.02L19 5.14c-.61-1.04-1.73-1.73-3-1.73s-2.39.69-2.99 1.71v.02L2.46 23.39a3.476 3.476 0 0 0 3 5.2ZM16 21.04c1.1 0 2 .89 2 2s-.89 2-2 2-2-.89-2-2a2 2 0 0 1 2-2m-2-9.92s-.01-.1-.01-.15c0-.55.45-1 1-1h2.02c.55 0 1 .45 1 1 0 .05 0 .1-.01.16s-1 6.99-1 6.99c0 .55-.45 1-1 1s-1-.45-1-1z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M26.9 29.29H4.3c-1.23 0-2.34-.63-2.96-1.69a3.38 3.38 0 0 1-.05-3.41L12.58 3.64c.61-1.12 1.74-1.78 3.02-1.78s2.4.67 3.02 1.78l11.3 20.54c.59 1.08.57 2.35-.05 3.41s-1.74 1.69-2.97 1.69ZM3.29 25.28c-.29.52-.08.98.02 1.15s.4.57 1 .57H26.9c.6 0 .9-.4 1-.57s.31-.63.02-1.15L16.62 4.74c-.3-.54-.81-.6-1.01-.6s-.72.06-1.01.6z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.6 19c-.63 0-1.14-.51-1.14-1.14V11a1.14 1.14 0 1 1 2.28 0v6.86c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "15.6",
        cy: "23",
        r: ".57"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.6 24.71c-.94 0-1.71-.77-1.71-1.71s.77-1.71 1.71-1.71 1.71.77 1.71 1.71-.77 1.71-1.71 1.71m0-2.28a.57.57 0 1 0 0 1.14.57.57 0 0 0 0-1.14"
      })]
    })
  }));
};
WarningIcon.displayName = 'WarningIcon';